import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3eea8090"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reset-pass" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "reset-pass-body" }
const _hoisted_5 = {
  key: 0,
  class: "lm-column pass-error"
}
const _hoisted_6 = { class: "lm-column" }
const _hoisted_7 = { class: "license-info" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "license-info-label" }, "New Password", -1))
const _hoisted_9 = { class: "lm-column" }
const _hoisted_10 = { class: "license-info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "license-info-label" }, "Repeat Password", -1))
const _hoisted_12 = { class: "update-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.modalHeader), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_ctx.passError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.passError), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_InputText, {
            type: "password",
            placeholder: "Password",
            class: "form-control",
            modelValue: _ctx.password1,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password1) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_InputText, {
            type: "password",
            placeholder: "Repeat Password",
            class: "form-control",
            modelValue: _ctx.password2,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password2) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          label: "Send",
          class: "p-button-secondary p-button",
          disabled: !_ctx.isFormValid,
          onClick: _ctx.submitForm
        }, null, 8, ["disabled", "onClick"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          onClick: _ctx.cancelForm,
          label: "Cancel",
          class: "p-button-secondary p-button-outlined"
        }, null, 8, ["onClick"])
      ])
    ])
  ]))
}